export default __webpack_public_path__ + "static/media/insta09.61a3e326.webp";